module.exports = __webpack_public_path__ + "img/thumb_tribute_no2.8c1d0d8c.jpg";